import { persist, createJSONStorage } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

interface AuthTokenState {
  token: string | null;
  account: string | null;
  setToken: (token: string | null, account?: string) => void;
  clearToken: () => void;
}

// This is a local expiry check only; the backend still verifies the JWT.
export const isUnexpiredToken = (token: string | null): boolean => {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload.exp === 'number' && payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

export const authTokenStore = createStore<AuthTokenState>()(
  persist(
    set => ({
      token: null,
      account: null,
      setToken: (token, account) => set({ token, account: token ? (account?.toLowerCase() ?? null) : null }),
      clearToken: () => set({ token: null, account: null }),
    }),
    {
      name: 'dpin-auth-token-v1',
      storage: createJSONStorage(() => window.localStorage),
      partialize: state => ({ token: state.token, account: state.account }),
    }
  )
);

export const getAuthToken = () => {
  const token = authTokenStore.getState().token;
  return isUnexpiredToken(token) ? token : null;
};
export const setAuthToken = (token: string | null, account?: string) => authTokenStore.getState().setToken(token, account);
export const clearAuthToken = () => authTokenStore.getState().clearToken();
